/**
 * Custom hook to determine media query breakpoint at JSX layer.
 *
 */

import { useState, useEffect } from "react";
import _ from "lodash";

const getDeviceConfig = (width) => {
  if (width < 480) {
    return "xs";
  } else if (width >= 480 && width < 600) {
    return "sm_phone";
  } else if (width >= 600 && width < 768) {
    return "sm";
  } else if (width >= 768 && width < 992) {
    return "md";
  } else if (width >= 992 && width < 1200) {
    return "lg";
  } else {
    return "xl";
  }
};

const useBreakpoint = () => {
  const [brkPnt, setBrkPnt] = useState(() =>
    getDeviceConfig(typeof window !== "undefined" && window.innerWidth)
  );

  useEffect(() => {
    const calcInnerWidth = _.throttle(function () {
      setBrkPnt(
        getDeviceConfig(typeof window !== "undefined" && window.innerWidth)
      );
    }, 200);

    if (typeof window !== "undefined") {
      window.addEventListener("resize", calcInnerWidth);

      return () => window.removeEventListener("resize", calcInnerWidth);
    }
  }, []);

  return brkPnt;
};

export default useBreakpoint;
